import { Injectable, inject } from '@angular/core';
import { BannerNotificationStore } from '../stores/banner-notification.store';
import { BannerNotification, MaintenanceMode } from '../models/banner-notification.model';

@Injectable({
  providedIn: 'root',
})
export class BannerNotificationService {
  private bannerNotificationStore = inject(BannerNotificationStore);

  readonly isLoading = this.bannerNotificationStore.loading;
  readonly maintenanceMode = this.bannerNotificationStore.maintenanceMode;
  readonly bannerNotifications = this.bannerNotificationStore.bannerNotifications;
  readonly dismissedBanners = this.bannerNotificationStore.dismissedBanners;

  async getMaintenanceMode(): Promise<MaintenanceMode[]> {
    return this.bannerNotificationStore.fetchMaintenanceMode();
  }

  async getBannerNotifications(): Promise<BannerNotification[]> {
    return this.bannerNotificationStore.fetchBannerNotifications();
  }

  async dismissBannerNotification(bannerType: string, refetch = false): Promise<boolean> {
    return this.bannerNotificationStore.dismissBanner(bannerType, refetch);
  }

  isBannerDismissed(bannerType: string): boolean {
    return this.bannerNotificationStore.isBannerDismissed(bannerType);
  }

  resetState(): void {
    this.bannerNotificationStore.resetState();
  }
}
